import type { CSSProperties } from "react";
import { cn } from "../lib/utils";
import { profilePhotoObjectStyle } from "../lib/profile-photo-style";

export type ProfilePhotoAvatarProps = {
  src: string;
  alt: string;
  /** Valeur CSS object-position (ex. "50% 30%"). */
  position?: string | null;
  /** Taille du conteneur circulaire (ex. "h-28 w-28"). */
  className?: string;
  imageClassName?: string;
  imageStyle?: CSSProperties;
};

/**
 * Avatar circulaire avec recadrage `object-position` — même rendu que l'éditeur
 * de photo de profil et la vitrine publique.
 */
export const ProfilePhotoAvatar = ({
  src,
  alt,
  position,
  className,
  imageClassName,
  imageStyle,
}: ProfilePhotoAvatarProps) => (
  <div
    className={cn(
      "bg-muted relative shrink-0 overflow-hidden rounded-full",
      className,
    )}
  >
    <img
      src={src}
      alt={alt}
      draggable={false}
      style={{ ...profilePhotoObjectStyle(position), ...imageStyle }}
      className={cn("pointer-events-none h-full w-full object-cover", imageClassName)}
    />
  </div>
);
